import React from "react";
import { ReportHeader } from "../../../../../../../components/ReportHeader/ReportHeader";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import { CircularProgress } from "../../../../../../../../../shared/CircularProgress/CircularProgress";
import { svg } from "../../../../../../../../../assets/svg";
import { Button } from "../../../../../../../../../shared/Button/Button";

const Header = ({ backFunc, download }) => {
  const { tCommon } = useAppTranslation.Common();
  const { tBi } = useAppTranslation.BusinessInsights();
  return (
    <ReportHeader
      withBackBtn
      backFunc={backFunc}
      media="small"
      label={tBi("verticalsUsageReport.label")}
    >
      <Button
        size="small"
        variant="outlined"
        onClick={download.initiate}
        isDisabled={download.isLoading}
        leftAdornment={
          download.isLoading ? (
            <CircularProgress size="small" />
          ) : (
            <img src={svg.downloadPrimary} alt="dl" width="20px" />
          )
        }
      >
        {tCommon("label.downloadExcel")}
      </Button>
    </ReportHeader>
  );
};

export default Header;
